import { DocumentType, Document } from '@/plugins/api'
import { chunk, keyBy } from 'lodash-es'
export default {
  namespaced: true,
  state: {
    documentTypes: []
  },
  actions: {
    async fetchDocumentTypes({ commit }, { createdTeacher, ...options }) {
      const documentTypes = await DocumentType.fetch({ ...options, _sort: 'index:ASC', _limit: -1 })
      const documentObj = keyBy(documentTypes, 'id')
      const groups = chunk(documentTypes, 5)
      for (const subTypes of groups) {
        await Promise.all(
          subTypes.map(async t => {
            const fileNo = await Document.count({ documentType: t.id, createdTeacher })
            documentObj[t.id].fileNo = fileNo.toString()
          })
        )
      }

      commit('changeState', { documentTypes: Object.values(documentObj) })
    },
    async createDocumentType({ commit, state }, data) {
      data = { ...data, index: state.documentTypes.length + 1 }
      const t = await DocumentType.create(data)
      commit('createDocumentType', t)
      return t
    },
    async removeDocumentType({ commit }, documentType) {
      await DocumentType.remove(documentType.id)
      // update index
      const afterItems = await DocumentType.fetch({
        index_gt: documentType.index,
        _limit: -1
      })
      const groups = chunk(afterItems, 5)
      for (const subTypes of groups) {
        const promises = subTypes.map(type => DocumentType.update(type.id, { index: type.index - 1 }))
        await Promise.all(promises)
      }
      commit('removeDocumentType', documentType.id)
    },
    async updateDocumentType({ commit }, { id, ...type }) {
      const g = await DocumentType.update(id, type)
      commit('updateDocumentType', g)
    },
    async updateIndex(_, options) {
      const { itemMoving, oldIndex, newIndex } = options
      await DocumentType.update(itemMoving.id, { index: newIndex })

      if (newIndex > oldIndex) {
        // di chuyển item xuống
        const beforeItems = await DocumentType.fetch({
          index_gt: oldIndex,
          index_lte: newIndex,
          id_ne: itemMoving.id,
          _limit: -1
        })
        const groups = chunk(beforeItems, 5)
        for (const subTypes of groups) {
          const promises = subTypes.map(type => DocumentType.update(type.id, { index: type.index - 1 }))
          await Promise.all(promises)
        }
      } else {
        // di chuyển item lên
        const afterItems = await DocumentType.fetch({
          index_gte: newIndex,
          index_lt: oldIndex,
          id_ne: itemMoving.id,
          _limit: -1
        })
        const groups = chunk(afterItems, 5)
        for (const subTypes of groups) {
          const promises = subTypes.map(type => DocumentType.update(type.id, { index: type.index + 1 }))
          await Promise.all(promises)
        }
      }
    }
  },
  mutations: {
    updateDocumentType(state, documentType) {
      state.documentTypes = state.documentTypes.map(g => {
        if (documentType.id === g.id) return documentType
        else return g
      })
    },
    createDocumentType(state, documentType) {
      state.documentTypes = [{ ...documentType, fileNo: '0' }, ...state.documentTypes]
    },
    removeDocumentType(state, id) {
      state.documentTypes = state.documentTypes.filter(documentType => documentType.id !== id)
    }
  }
}
